import React from 'react';
import { Button, Col, Collapse, message, Row } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { activateReferralAction } from 'store/slices/account/actions';
import { RootState } from '../../../types/RootState';
import { useTranslation } from 'react-i18next';

const { Panel } = Collapse;

export function Rules(): React.ReactElement {
  const dispatch = useDispatch();
  const { account, isActivatingReferral: loading } = useSelector(
    (state: RootState) => state.account,
  );
  const [t] = useTranslation();
  const handleRefererOk = () => {
    dispatch(activateReferralAction.request()).then(() => {
      message.success(t('app.account.referrals.activated'));
    });
  };
  return (
    <div className="box">
      <Collapse defaultActiveKey={['1']} ghost accordion={true}>
        <Panel key="1" header={t('app.account.referrals.rules.panel_1.title')}>
          <p>
            {t('app.account.referrals.rules.panel_1.body')}
            <br />
            <br />- {t('app.account.referrals.rules.panel_1.rule_1')}
            <br />
            <br />- {t('app.account.referrals.rules.panel_1.rule_2')}
            <br />
            <br />- {t('app.account.referrals.rules.panel_1.rule_3')}
            <br />
            <br />- {t('app.account.referrals.rules.panel_1.rule_4')}
            <br />
            <br />- {t('app.account.referrals.rules.panel_1.rule_5')}
          </p>
        </Panel>
        <Panel header={t('app.account.referrals.rules.panel_2.title')} key="2">
          <p>
            {t('app.account.referrals.rules.panel_2.body')}
            <span style={{ marginRight: '10px' }}>
              <br />
              <br />- {t('app.account.referrals.rules.panel_2.rule_1')}
              <br />
              <br />- {t('app.account.referrals.rules.panel_2.rule_2')}
              <br />
              <br />- {t('app.account.referrals.rules.panel_2.rule_3')}
              <br />
              <br />- {t('app.account.referrals.rules.panel_2.rule_4')}
              <br />
              <br />- {t('app.account.referrals.rules.panel_2.rule_5')}
              <br />
              <br />
            </span>
            {t('app.account.referrals.rules.panel_2.footer')}
          </p>
        </Panel>
      </Collapse>
      <div>
        <Row gutter={16} style={{ marginTop: '35px' }}>
          <Col span={12} offset={6}>
            <Button
              block
              type="primary"
              loading={loading}
              htmlType="button"
              onClick={handleRefererOk}
              disabled={account?.refNumber !== null}
            >
              {t('app.account.referrals.activate')}
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
}
